export default __webpack_public_path__ + "static/media/guide-8.61040917.png";